export const SETTING_BASE_ROUTE = '/settings';
